// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__JiARO","content":"LoadingAlert_content__1dPzF"};